import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import styled from "styled-components"
import getGatsbyImage from "utils/getGatsbyImage"

const Wrapper = styled.div``

const Content = styled.div`
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  padding: 30px 20px;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 0.9rem;
`

const Element = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 140px;
  padding: 0 10px;
  > :first-child {
    width: 70px;
    height: 70px;
    * {
      object-fit: contain !important;
    }
    margin-bottom: 15px;
  }
`

interface IProps {
  elements: {
    image: any
    text: string
  }[]
}

const BigIconsHero = (props: IProps) => (
  <Wrapper>
    <Content>
      {props.elements.map((e, i) => (
        <Element key={i}>
          <GatsbyImage
            image={getGatsbyImage(e.image.localFile)}
            alt={e.text || ""}
          />
          <div>{e.text}</div>
        </Element>
      ))}
    </Content>
  </Wrapper>
)

export default BigIconsHero
